import { Badge } from '@mantine/core';
import type { FC } from 'react';
import { useHomeContext } from '../../context';
import { useCuisineBadgeStyles } from './styles';
import { Tag } from '../../services/tag/tag.schema';

type Props = {
  tag: Tag;
};

const CuisineBadge: FC<Props> = ({ tag }) => {
  const { classes, cx } = useCuisineBadgeStyles();

  const { selectedTagId, setSelectedTagId } = useHomeContext();

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    setSelectedTagId(tag.tag_id);
  };

  return (
    <>
      <Badge
        onClick={handleClick}
        className={cx(classes.badge, {
          [classes.selectedBadge]: selectedTagId === tag.tag_id,
          [classes.unselectedBadge]: selectedTagId !== tag.tag_id,
        })}
        styles={(theme) => ({
          root: {
            display: 'flex',
            alignItems: 'center',
            height: 24,
            '&:not(:last-child)': {
              marginRight: '0.25rem',
            },
          },
        })}>
        <p>{tag.name}</p>
      </Badge>
    </>
  );
};

export default CuisineBadge;
